import React from 'react';
import { ProjectDocsHeader } from './ProjectDocsHeader';
import { ProjectDocsExplorer } from './ProjectDocsExplorer';
import { ProjectDocsSidebar } from './ProjectDocsSidebar';

export function ProjectDocsMain() {
  return (
    <div className="space-y-6">
      {/* Header Điều khiển */}
      <ProjectDocsHeader />

      <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 items-start">
        {/* Nội dung chính: Explorer (Tree + List) */}
        <div className="xl:col-span-9">
          <ProjectDocsExplorer />
        </div>

        {/* Sidebar: Stats & Recent */}
        <div className="xl:col-span-3 space-y-6">
          <ProjectDocsSidebar />
        </div>
      </div>
    </div>
  );
}
